module.exports = __webpack_public_path__ + "223a277bd88d8a90c8cdf24cda0ad5f5.woff2";